<template>
    <div>
      <v-collapse-wrapper :active="true">
        <div class="a-tab__title-block admin__a-tab admin__a-tab--modification-controls"
             v-collapse-toggle>
          <h3>{{$t('form.lot.overview-lot-details')}}</h3>
        </div>
        <div class="admin__a-tab-content admin__a-tab-content--show" v-collapse-content>
          <div class="a-container-form ">
            <div class="a-label a-label--w-280">{{$t('labels.lot-number')}}:</div>
            <p class="a-input a-input--disabled">{{lot.identifier}}</p>
          </div>

          <div class="a-container-form a-container-form--align-start" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_STATISTICS">
            <div class="a-label a-label--w-280">{{$t('form.lot.person-opened-lot')}}:</div>
            <div class="a-flex-start u-line-height-23">
              <expandable-list :value="lot.statistics.sawLot">
                <template v-slot:item="{ item }">
                  <p class="a-input a-input--disabled a-width-100-percent">
                    {{item.organization}} ({{item.email}})
                  </p>
                </template>
              </expandable-list>
            </div>
          </div>

          <div class="a-container-form ">
            <div class="a-label a-label--w-280">{{$t('form.tender.tender-number')}}:</div>
            <p class="a-input a-input--disabled">{{lot.tenderNum}}</p>
          </div>
          <div class="a-container-form ">
            <div class="a-label a-label--w-280">{{$t('form.tender.tender-publish-datetime')}}:</div>
            <date-time class="a-input a-input--disabled" :value="lot.publicationDate"></date-time>
          </div>
          <div class="a-container-form " v-if="lot.lastChangeDate">
            <div class="a-label a-label--w-280">{{$t('form.tender.tender-publish-changes-datetime')}}:</div>
            <date-time class="a-input a-input--disabled" :value="lot.lastChangeDate"></date-time>
          </div>
          <div class="a-container-form a-container-form--align-start">
            <div class="a-label a-label--w-280">{{$t('form.lot.request-can-be-sent-until')}}:</div>
            <date-time class="a-input a-input--disabled" :value="lot.receivingRequestsDueDate"></date-time>
          </div>
          <div class="a-container-form " v-if="lot.changeLotDescription">
            <div class="a-label a-label--w-280">{{$t('form.lot.last-changes-description')}}:</div>
            <span class="a-input a-input--disabled u-red-color">{{lot.changeLotDescription}}</span>
          </div>
          <div class="a-container-form " v-if="lot.changeTenderDescription">
            <div class="a-label a-label--w-280">{{$t('form.tender.last-change-description')}}:</div>
            <span class="a-input a-input--disabled u-red-color">{{lot.changeTenderDescription}}</span>
          </div>

          <lot-history :lot="lot"></lot-history>

          <div class="a-container-form ">
            <div class="a-label a-label--w-280">{{$t('form.lot.lot-stage')}}:</div>
            <p class="a-input a-input--disabled">{{$t(lot.state.label)}}</p>
          </div>
          <div class="a-container-form ">
            <div class="a-label a-label--w-280">{{$t('form.tender.customer')}}:</div>
            <p class="a-input a-input--disabled">{{customerTitle}}</p>
          </div>
<!--          <div class="a-container-form ">-->
<!--            <div class="a-label a-label&#45;&#45;w-280">{{$t('form.tender.originator')}}:</div>-->
<!--            <p class="a-input a-input&#45;&#45;disabled">{{lot.originator | fullName}}</p>-->
<!--          </div>-->
          <div class="a-container-form ">
            <div class="a-label a-label--w-280">{{$t('form.tender.initiator-contact-details')}}:</div>
            <p class="a-input a-input--disabled">
              {{lot.originator | fullName}}
              <br> {{lot.originator.email}}
              <br> {{lot.originator.phone}}
            </p>
          </div>
          <div class="a-container-form ">
            <div class="a-label a-label--w-280">{{$t('form.lot.tender-subject')}}:</div>
            <p class="a-input a-input--disabled">{{lot.name}}</p>
          </div>
          <div class="a-container-form ">
            <div class="a-label a-label--w-280">{{$t('form.lot.tender-categories')}}</div>
            <p class="a-input a-input--disabled">{{lot.categories.map(e => e.name) | shortList(10)}}</p>
          </div>
          <div class="a-container-form ">
            <div class="a-label a-label--w-280">{{$t('form.lot.lot-initial-price')}}:</div>
            <p class="a-input a-input--disabled">{{lot.initialPrice | price}} {{$t(lot.currency.label)}}</p>
          </div>
          <div class="a-container-form ">
            <div class="a-label a-label--w-280">{{$t('form.lot.lot-currency')}}:</div>
            <p class="a-input a-input--disabled">{{$t(lot.currency.label)}}</p>
          </div>
          <div class="a-container-form ">
            <div class="a-label a-label--w-280">{{$t('form.lot.taxes')}}:</div>
            <p class="a-input a-input--disabled">{{lot.withTaxes ? $t('form.lot.with-taxes') : $t('form.lot.without-taxes')}}</p>
          </div>
          <div class="a-container-form " v-if="lot.threshold.isSet">
            <div class="a-label a-label--w-280">{{$t('form.lot.dumping-threshold')}}:</div>
            <p class="a-input a-input--disabled" v-if="lot.threshold.isPercent">{{lot.threshold.value | percent}} %</p>
            <p class="a-input a-input--disabled" v-else>{{lot.threshold.value | price}} {{$t(lot.currency.label)}}</p>
          </div>
          <div class="a-container-form ">
            <div class="a-label a-label--w-280">{{$t('form.lot.other-description')}}:</div>
            <p class="a-input a-input--disabled">{{lot.description}}</p>
          </div>
          <div class="a-container-form ">
            <div class="a-label a-label--w-280">{{$t('form.tender.address')}}:</div>
            <button class="gui-btn gui-btn--link">{{customerAddress}}</button>
          </div>
          <div class="a-container-form ">
            <div class="a-label a-label--w-280">{{$t('form.tender.tender-method')}}:</div>
            <p class="a-input a-input--disabled">{{$t(lot.method.label)}}</p>
          </div>
          <div class="a-container-form ">
            <div class="a-label a-label--w-280">{{$t('form.lot.signed-by-owner')}}:</div>
            <p class="a-input a-input--disabled">{{lot.isSignedByOriginator ? $t('labels.yes') : $t('labels.no')}}</p>
          </div>
          <div class="a-container-form ">
            <div class="a-label a-label--w-280">
              {{$t('form.lot.participant-should-sign')}}:
            </div>
            <p class="a-input a-input--disabled">{{lot.isSignatureRequired ? $t('labels.yes') : $t('labels.no')}}</p>
          </div>
          <div class="a-container-form a-container-form--align-start" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_COMMISSION">
            <div class="a-label a-label--w-280">{{$t('form.tender.commission-members')}}:</div>
            <div class="a-flex-start u-line-height-23">
              <expandable-list :value="lot.commission">
                <template v-slot:item="{ item }">
                  <p class="a-input a-input--disabled a-width-100-percent">
                    {{item | fullName}} ({{item.email}})
                  </p>
                </template>
              </expandable-list>
            </div>
          </div>
          <div class="a-container-form " v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_PLANNED_REVIEWING_REQUESTS_DURATION">
            <p class="a-input a-input--disabled a-width-100-percent">
              Оценка заявок на соответствие требованиям Заказчика не более <span class="a-color-red">{{lot.durations.reviewingRequests.planned}}</span> календарных дней с момента окончания приема заявок на участие
            </p>
          </div>
          <div class="a-container-form " v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_PLANNED_REVIEWING_REQUESTS_BY_CRITERIA_DURATION">
            <p class="a-input a-input--disabled a-width-100-percent">
              Оценка предложений допущеных заявок по критериям не более <span class="a-color-red">{{lot.durations.reviewingRequestsByCriteria.planned}}</span> календарных дней с момента окончания оценки заявок на соответствие требованиям Заказчика
            </p>
          </div>
          <div class="a-container-form ">
            <div class="a-label a-label--w-280">{{$t('form.tender.participation-mode')}}:</div>
            <p class="a-input a-input--disabled">{{$t(lot.participationMode.label)}}</p>
          </div>
          <div class="a-container-form a-container-form--align-start" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_ACTUAL_RECEIVING_REQUESTS_DURATION">
            <div class="a-label a-label--w-280">{{$t('form.lot.durations.receiving-requests')}}: </div>
            <div class="a-flex-start">
              <div class="a-input-text-after-before">
                <p>{{$tc('form.lot.actual-duration-in-days', lot.durations.receivingRequests.actual)}}</p>
              </div>
            </div>
          </div>
          <div class="a-container-form a-container-form--align-start" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_ACTUAL_REVIEWING_REQUESTS_DURATION || lot.permissions.CAN_SEE_PUBLIC_LOT_PLANNED_REVIEWING_REQUESTS_DURATION">
            <div class="a-label a-label--w-280">{{$t('form.lot.durations.reviewing-request')}}:</div>
            <div class="a-flex-start">
              <div class="a-input-text-after-before" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_ACTUAL_REVIEWING_REQUESTS_DURATION">
                <p>{{$tc('form.lot.actual-duration-in-days', lot.durations.reviewingRequests.actual)}}</p>
              </div>
              <div class="a-input-text-after-before" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_PLANNED_REVIEWING_REQUESTS_DURATION">
                <p>{{$tc('form.lot.planned-duration-in-days', lot.durations.reviewingRequests.planned)}}</p>
              </div>
            </div>
          </div>
          <div class="a-container-form a-container-form--align-start" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_ACTUAL_REVIEWING_REQUESTS_BY_CRITERIA_DURATION || lot.permissions.CAN_SEE_PUBLIC_LOT_PLANNED_REVIEWING_REQUESTS_BY_CRITERIA_DURATION">
            <div class="a-label a-label--w-280">{{$t('form.lot.durations.estimating-bids')}}:</div>
            <div class="a-flex-start">
              <div class="a-input-text-after-before" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_ACTUAL_REVIEWING_REQUESTS_BY_CRITERIA_DURATION">
                <p>{{$tc('form.lot.actual-duration-in-days', lot.durations.reviewingRequestsByCriteria.actual)}}</p>
              </div>
              <div class="a-input-text-after-before" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_PLANNED_REVIEWING_REQUESTS_BY_CRITERIA_DURATION">
                <p>{{$tc('form.lot.planned-duration-in-days', lot.durations.reviewingRequestsByCriteria.planned)}}</p>
              </div>
            </div>
          </div>
          <div class="a-container-form a-container-form--align-start" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_ACTUAL_RETEND_DURATION || lot.permissions.CAN_SEE_PUBLIC_LOT_PLANNED_RETEND_DURATION">
            <div class="a-label a-label--w-280">{{$t('form.lot.durations.retend')}}:</div>
            <div class="a-flex-start">
              <div class="a-input-text-after-before" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_ACTUAL_RETEND_DURATION">
                <p>{{$tc('form.lot.actual-duration-in-days', lot.durations.retend.actual)}}</p>
              </div>
              <div class="a-input-text-after-before" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_PLANNED_RETEND_DURATION">
                <p>{{$tc('form.lot.planned-duration-in-days', lot.durations.retend.planned)}}</p>
              </div>
            </div>
          </div>
          <div class="a-container-form a-container-form--align-start" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_ACTUAL_SPLITTING_PRICE_DURATION || lot.permissions.CAN_SEE_PUBLIC_LOT_PLANNED_SPLITTING_PRICE_DURATION">
            <div class="a-label a-label--w-280">{{$t('form.lot.durations.dividing-final-cost')}}:</div>
            <div class="a-flex-start">
              <div class="a-input-text-after-before" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_ACTUAL_SPLITTING_PRICE_DURATION">
                <p>{{$tc('form.lot.actual-duration-in-days', lot.durations.splittingPrice.actual)}}</p>
              </div>
              <div class="a-input-text-after-before" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_PLANNED_SPLITTING_PRICE_DURATION">
                <p>{{$tc('form.lot.planned-duration-in-days', lot.durations.splittingPrice.planned)}}</p>
              </div>
            </div>
          </div>
          <div class="a-container-form a-container-form--align-start" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_ACTUAL_ACCEPT_DURATION || lot.permissions.CAN_SEE_PUBLIC_LOT_PLANNED_ACCEPT_DURATION">
            <div class="a-label a-label--w-280">{{$t('form.lot.durations.accepting')}}:</div>
            <div class="a-flex-start">
              <div class="a-input-text-after-before" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_ACTUAL_ACCEPT_DURATION">
                <p>{{$tc('form.lot.actual-duration-in-days', lot.durations.accept.actual)}}</p>
              </div>
              <div class="a-input-text-after-before" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_PLANNED_ACCEPT_DURATION">
              <p>{{$tc('form.lot.planned-duration-in-days', lot.durations.accept.planned)}}</p>
              </div>
            </div>
          </div>
          <div class="a-container-form a-container-form--align-start" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_ACTUAL_WAITING_FOR_FIRST_RETEND_DURATION || lot.permissions.CAN_SEE_PUBLIC_LOT_PLANNED_WAITING_FOR_FIRST_RETEND_DURATION">
            <div class="a-label a-label--w-280">{{$t('form.lot.durations.waiting-for-first-retend')}}:</div>
            <div class="a-flex-start">
              <div class="a-input-text-after-before" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_ACTUAL_WAITING_FOR_FIRST_RETEND_DURATION">
                <p>{{$tc('form.lot.actual-duration-in-days', lot.durations.waitingForFirstRetend.actual)}}</p>
              </div>
              <div class="a-input-text-after-before" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_PLANNED_WAITING_FOR_FIRST_RETEND_DURATION">
                <p>{{$tc('form.lot.planned-duration-in-days', lot.durations.waitingForFirstRetend.planned)}}</p>
              </div>
            </div>
          </div>
          <div class="a-container-form a-container-form--align-start" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_ACTUAL_TENDER_DURATION || lot.permissions.CAN_SEE_PUBLIC_LOT_PLANNED_TENDER_DURATION">
            <div class="a-label a-label--w-280">{{$t('form.lot.durations.tender-duration')}}:</div>
            <div class="a-flex-start">
              <div class="a-input-text-after-before" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_ACTUAL_TENDER_DURATION">
                <p>{{$tc('form.lot.actual-duration-in-days', lot.durations.tender.actual)}}</p>
              </div>
              <div class="a-input-text-after-before" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_PLANNED_TENDER_DURATION">
                <p>{{$tc('form.lot.planned-duration-in-days', lot.durations.tender.planned)}}</p>
              </div>
            </div>
          </div>
          <div class="a-container-form a-container-form--align-start" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_ACTUAL_CONTRACT_CONCLUSION_DURATION || lot.permissions.CAN_SEE_PUBLIC_LOT_PLANNED_CONTRACT_CONCLUSION_DURATION">
            <div class="a-label a-label--w-280">{{$t('form.lot.durations.contract-conclusion')}}:</div>
            <div class="a-flex-start">
              <div class="a-input-text-after-before" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_ACTUAL_CONTRACT_CONCLUSION_DURATION">
                <p>{{$tc('form.lot.actual-duration-in-days', lot.durations.contractConclusion.actual)}}</p>
              </div>
              <div class="a-input-text-after-before" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_PLANNED_CONTRACT_CONCLUSION_DURATION">
                <p>{{$tc('form.lot.planned-duration-in-days', lot.durations.contractConclusion.planned)}}</p>
              </div>
            </div>
          </div>
          <div class="a-container-form a-container-form--align-start" v-if="lot.permissions.CAN_CREATE_PUBLIC_LOT_RETEND">
            <button class="gui-btn gui-btn--red" @click.prevent="onCreateRetendClick">
              {{$t('buttons.create-notice-about-retend')}}
            </button>
          </div>
          <v-collapse-group class="a-ui-tab" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_RETEND">
            <div class="a-ui-tab__block" v-for="retend in lot.retends" :key="retend.id">
              <v-collapse-wrapper :active="true">
                <div class="a-ui-tab__control-panel">
                  <div class="a-ui-tab__control" v-collapse-toggle>
                    <div class="a-ui-tab__arrow"></div>
                    <div class="a-ui-tab__number-block">
                      <router-link :to="{
                                        name: 'retend-details',
                                          params: {
                                            lotId: lot.id,
                                            retendNum: retend.serial,
                                            tab: 'overview'
                                          }
                                        }"
                                   class="table-tab__color u-text-underline"
                                   v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_RETEND_DETAILS" >
                        {{$t('form.retend.title', {id: retend.serial})}}
                      </router-link>
                      <span v-else>
                        {{$t('form.retend.title', {id: retend.serial})}}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="a-ui-tab__content-block" v-collapse-content>
                  <div class="a-ui-tab__content">
                    <div class="a-container-form ">
                      <div class="a-label a-label--w-220">{{$t('form.retend.will-start-at')}}:</div>
                      <date-time class="a-input a-input--disabled" :value="retend.startTime"></date-time>
                    </div>
                    <div class="a-container-form ">
                      <div class="a-label">{{$t('form.retend.step')}}:</div>
                      <p class="a-input a-input--disabled">{{retend.step | price }} {{retend.currency.EMPTY ? '%' : $t(retend.currency.label)}}</p>
                    </div>
                    <div class="a-container-form ">
                      <div class="a-label">{{$t('form.retend.max-period-before-another-bid')}}:</div>
                      <p class="a-input a-input--disabled">{{retend.waitingTime}} {{$t('labels.minutes')}}</p>
                    </div>
                    <div class="a-container-form ">
                      <div class="a-label">{{$t('form.retend.will-be-finished-at')}}:</div>
                      <date-time class="a-input a-input--disabled" :value="retend.endTime"></date-time>
                    </div>
                  </div>
                </div>
              </v-collapse-wrapper>
            </div>
          </v-collapse-group>
          <div class="u-indent-m-b-120px"></div>
        </div>
      </v-collapse-wrapper>
    </div>
</template>

<script>
  import _ from 'lodash'
  import LotHistory from "./LotHistory";

  export default {
    components: {LotHistory},
    props: {
      lot: Object
    },

    methods: {
      async onCreateRetendClick() {
        try {
          let retend = _.find(this.lot.retends, e => e.state.DRAFT);

          if (!retend) {
            const lot = await this.$store.dispatch('createRetend', { lotId: this.lot.id });
            retend = _.find(lot.retends, e => e.state.DRAFT);
          }

          if (retend) {
            const url = this.$router.resolve({
              name: 'retend-details',
              params: {
                lotId: this.lot.id,
                retendNum: retend.serial,
                tab: 'overview'
              }
            });
            window.open(url.href, '_blank');
          }
        }
        catch(e) {
          console.error('failed creating retend for lot', e);
          this.globalErrorHandler(e);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .a-flex-start {
    .a-input-text-after-before:not(first-child) {
      margin-left: 20px;
    }
  }
</style>
